<div id="experience-modal" *ngIf="isModalVisible">    
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-height: 70vh;">
    <div class="modal-content">
      <div class="modal-header" style="padding: 0.25rem;">
        <h5 class="modal-title" id="experienceModalLabel"
          style="font-size: 1.25rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">Explore BRS</h5>
        <button type="button" class="close" (click)="CloseModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 0.25rem;">
        <iframe id="experienceVideo" width="100%" height="300" src="https://www.youtube.com/embed/adEo19mS2c4"
          title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen></iframe>
      </div>
      <div class="modal-footer" style="padding: 0.25rem;">
        <button type="button" class="btn btn-secondary" (click)="CloseModal()">Close</button>
      </div>
    </div>
  </div>
</div>